export default __webpack_public_path__ + "static/media/030_corner_bad.40c3a400.mp3";